var render, staticRenderFns
import script from "./tweetsFormDialog.vue?vue&type=script&lang=js"
export * from "./tweetsFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e8e618",
  null
  
)

export default component.exports